import { Box, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Background = styled(Box)`
  position: absolute;
  width: 2954px;
  height: 1108px;
  transform: rotate(41.008deg);
  flex-shrink: 0;
  opacity: 0.06;
  background:
    ${({ theme }) =>
      `linear-gradient(259deg, ${getThemeColor('secondary', theme)} 100.89%, ${getThemeColor('purple', theme)} 78.39%)`},
    url('assets/login-background.png'),
    lightgray 50% / cover no-repeat;
  background-position: 30% 30%;
  background-blend-mode: color, normal;
  z-index: -1;
`

export const LeftContainer = styled(Box)`
  border-top-right-radius: ${({ theme }) => theme.border_radius.box};
  border-bottom-right-radius: ${({ theme }) => theme.border_radius.box};
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.12) 100%),
    url('/assets/login-image.jpg'),
    lightgray 50% / cover no-repeat;
  background-size: cover;
  background-position: center;

  @media (max-width: 768px) {
    display: none;
  }
`

export const LeftContainerOverlay = styled(Box)``

export const TextContainer = styled(Box)`
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(4px);
`

export const TextBox = styled(Box)`
  padding-left: 20px;
  border-left: 2px solid ${({ theme }) => getThemeColor('white', theme)};
`
